import { NAVIGATION_TREE_LIST } from '../../constants/navigation-tree-list';
import { NavigationInfoActionType, TNavigationActions } from './navigation.action';
import { TNavigationState } from './navigation.models';

export const intialNavigationState: TNavigationState = {
  selectedNavigationItem: null,
  navigationTreeList: NAVIGATION_TREE_LIST,
  customPageHeader: {
    value: null,
    showBack: false,
  },
};

export function navigationReducer(state = intialNavigationState, action: TNavigationActions): TNavigationState {
  switch (action.type) {
    case NavigationInfoActionType.SelectNavigationItem:
      return {
        ...state,
        selectedNavigationItem: action.payload,
      };
    case NavigationInfoActionType.SetCustomPageHeader:
      return {
        ...state,
        customPageHeader: { value: action.payload, showBack: action.showBack || false },
      };
    default:
      return state;
  }
}
